import Cookies from "js-cookie";

const isProduction = process.env.NODE_ENV === "production";
const DEFAULT_PATH = "/";

/**
 * Güvenli cookie seçenekleri (2026 React/OWASP best practices).
 * - secure: Sadece HTTPS (production)
 * - sameSite: 'strict' CSRF azaltır; cross-site isteklerde cookie gönderilmez
 * - path: Çerez kapsamı
 */
export const getSecureCookieOptions = () => ({
  path: DEFAULT_PATH,
  sameSite: "strict",
  ...(isProduction && { secure: true }),
});

/**
 * Token ve hassas çerezleri güvenli şekilde kaydeder.
 */
export const setSecureCookie = (name, value, options = {}) => {
  Cookies.set(name, value, {
    ...getSecureCookieOptions(),
    ...options,
  });
};

/**
 * Çerez siler (path aynı olmalı).
 */
export const removeSecureCookie = (name) => {
  Cookies.remove(name, { path: DEFAULT_PATH });
};

/**
 * Hassas çerezleri toplu siler (logout / token refresh fail).
 */
export const clearAuthCookies = () => {
  const names = ["AccessToken", "RefreshToken", "ExpiresIn", "UserId"];
  names.forEach((name) => removeSecureCookie(name));
};
